import { useSelector } from "react-redux";
import { selectShouldShowWaffleMenu } from "../../app/dataServiceFeatureFlagsSlice";

/**
 * Custom hook to manage the waffle menu feature flag
 * @returns Whether the waffle menu is enabled
 */
export const useWaffleMenuFeatureFlag = (): boolean => {
    return useSelector(selectShouldShowWaffleMenu);
};
